<template>
  <div>
  
    <v-layout row wrap> 
      <v-flex p-t-30>  
        <div class="tituloBox p-b-30 border-top"> 
          <div class="bg-primary barraTitulo"></div>
  
          <v-btn icon @click="openBox()" right absolute>  
            <v-icon>unfold_more</v-icon>  
          </v-btn>
  
          <h1 class="text-info font-size-18"> 
            Formulários e 
            <strong>Declarações</strong> 
          </h1>
  
        </div> 
      </v-flex>
  
    </v-layout>
  
    <v-layout row wrap v-show="showBox">  
      <v-flex infoDados> 
        <v-card> 
          <v-layout row wrap>  
            <v-flex xs12 sm4 pa-0>  
              <v-card>  
                <v-card-title>
  
                  <h4> 
                    <strong>{{$t('label.termoConcordanciaVeracidade')}}www</strong> 
                  </h4>
  
                </v-card-title>
  
                <v-divider></v-divider>
  
                <v-list dense> 
                  <v-list-tile> 
                    <v-list-tile-content v-show="!uploadDeclaracao.termoConcordanciaVeracidade "><span v-html="nomeAnexoIfCadatrado(uploadDeclaracao.termoConcordanciaVeracidade)"></span></v-list-tile-content>  
                    <v-list-tile-content style="align-items: center;">
  
                      <a v-if="uploadDeclaracao.termoConcordanciaVeracidade && uploadDeclaracao.termoConcordanciaVeracidade != 'Não Encontrado' " @click="baixarArquivo(uploadDeclaracao.termoConcordanciaVeracidade)"> 
                        <v-icon color="blue">attach_file</v-icon> 
                      </a>

                      <v-icon v-if="uploadDeclaracao.termoConcordanciaVeracidade == 'Não Encontrado'" color="grey" ti>attach_file</v-icon>
  
                    </v-list-tile-content>  
                  </v-list-tile> 
                </v-list> 
              </v-card> 
            </v-flex>
   
            <v-flex xs12 sm4 pa-0>  
              <v-card> 
                <v-card-title>
 
                  <h4>  
                    <strong>{{$t('label.comprovanteResidencia')}}</strong> 
                  </h4>
  
                </v-card-title>
                <br>
  
                <v-divider></v-divider>
  
                <v-list dense>  
                  <v-list-tile> 
                    <v-list-tile-content v-show="!uploadDeclaracao.comprovanteResidencia "><span v-html="nomeAnexoIfCadatrado(uploadDeclaracao.comprovanteResidencia)"></span></v-list-tile-content> 
                    <v-list-tile-content style="align-items: center;">
  
                      <a v-if="uploadDeclaracao.comprovanteResidencia && uploadDeclaracao.comprovanteResidencia != 'Não Encontrado' " @click="baixarArquivo(uploadDeclaracao.comprovanteResidencia)"> 
                        <v-icon color="blue">attach_file</v-icon> 
                      </a>

                      <v-icon v-if="uploadDeclaracao.comprovanteResidencia == 'Não Encontrado'" color="grey" ti>attach_file</v-icon>
  
                    </v-list-tile-content> 
                  </v-list-tile>  
                </v-list>  
              </v-card> 
            </v-flex>
   
            <v-flex xs12 sm4 pa-0> 
              <v-card>  
                <v-card-title>
  
                  <h4>
                    <strong v-if="model.flagEstrangeiro === '0'">{{$t('label.procuracao')}}</strong>
                    <strong v-else>{{$t('label.procuracaoEstrangeiro')}}</strong>
                  </h4>
  
                </v-card-title>
                <br>
  
                <v-divider></v-divider>
  
                <v-list dense>
                  <v-list-tile>
                    <v-list-tile-content v-show="!uploadDeclaracao.procuracao"><span v-html="nomeAnexoIfCadatrado(uploadDeclaracao.procuracao)"></span></v-list-tile-content>
                    <v-list-tile-content style="align-items: center;">
  
                      <a v-if="uploadDeclaracao.procuracao && uploadDeclaracao.procuracao != 'Não Encontrado' " @click="baixarArquivo(uploadDeclaracao.procuracao)">
                        <v-icon color="blue">attach_file</v-icon>
                      </a>

                      <v-icon v-if="uploadDeclaracao.procuracao == 'Não Encontrado'" color="grey" ti>attach_file</v-icon>
  
                    </v-list-tile-content> 
                  </v-list-tile> 
                </v-list> 
              </v-card> 
            </v-flex>
  
            <v-flex xs12 sm4 pa-0 v-show="model.tipoCertificado != '3'">
              <v-card>
                <v-card-title>
  
                  <h4>
                    <strong>{{$t('label.declaracaoEmpregador')}}</strong>  
                  </h4>
  
                </v-card-title>
                <br>
  
                <v-divider></v-divider>
  
                <v-list dense>
                  <v-list-tile> 
                    <v-list-tile-content v-show="!uploadDeclaracao.declaracaoEmpregador "><span v-html="nomeAnexoIfCadatrado(uploadDeclaracao.declaracaoEmpregador)"></span></v-list-tile-content>  
                    <v-list-tile-content style="align-items: center;">
  
                      <a v-if="uploadDeclaracao.declaracaoEmpregador && uploadDeclaracao.declaracaoEmpregador != 'Não Encontrado' "> 
                        <v-icon color="blue" @click="baixarArquivo(uploadDeclaracao.declaracaoEmpregador)">attach_file</v-icon> 
                      </a>

                      <v-icon v-if="uploadDeclaracao.declaracaoEmpregador == 'Não Encontrado'" color="grey" ti>attach_file</v-icon>                       
                    </v-list-tile-content>  
                  </v-list-tile>  
                </v-list>  
              </v-card>  
            </v-flex>
   
            <v-flex xs12 sm4 pa-0 v-show="model.tipoCertificado != '3'"> 
              <v-card>
                <v-card-title>

                  <h4>
                    <strong>{{$t('label.declaracaoSuperveniencia')}}</strong>
                  </h4>
  
                </v-card-title>
                <br>
  
                <v-divider></v-divider>
  
                <v-list dense>
                  <v-list-tile>
                    <v-list-tile-content v-show="!uploadDeclaracao.declaracaoSuperveniencia "><span v-html="nomeAnexoIfCadatrado(uploadDeclaracao.declaracaoSuperveniencia)"></span></v-list-tile-content>
                    <v-list-tile-content style="align-items: center;">
  
                      <a v-if="uploadDeclaracao.declaracaoSuperveniencia && uploadDeclaracao.declaracaoSuperveniencia != 'Não Encontrado' " @click="baixarArquivo(uploadDeclaracao.declaracaoSuperveniencia)">
                        <v-icon color="blue">attach_file</v-icon>
                      </a>

                      <v-icon v-if="uploadDeclaracao.declaracaoSuperveniencia == 'Não Encontrado'" color="grey" ti>attach_file</v-icon>                      
  
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card>
            </v-flex>
  
            <v-flex xs12 sm4 pa-0 v-show="model.tipoCertificado != '3'">
              <v-card>
                <v-card-title>

                  <h4>
                    <strong>{{$t('label.declaracaoEnquadramento')}}</strong>
                  </h4>
  
                </v-card-title>
  
                <v-divider></v-divider>
                
                 <v-list dense v-if="$verificaPerfilCadastrador() || $verificaPerfilHabilitador()">
                  <v-list-tile>
                    <v-list-tile-content v-show="!uploadDeclaracao.declaracaoEnquadramento "><span v-html="nomeAnexoIfCadatrado(uploadDeclaracao.declaracaoEnquadramento)"></span></v-list-tile-content>
                    <v-list-tile-content style="align-items: center;">

                      <a v-if="uploadDeclaracao.declaracaoEnquadramento && uploadDeclaracao.declaracaoEnquadramento != 'Não Encontrado' " @click="baixarArquivo(uploadDeclaracao.declaracaoEnquadramento)">
                        <v-icon color="blue">attach_file</v-icon>
                      </a>

                      <v-icon v-if="uploadDeclaracao.declaracaoEnquadramento == 'Não Encontrado'" color="grey" ti>attach_file</v-icon>
 
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list> 
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>

  </div>
</template>

<script>
  import fornecedorService from "../../../services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */
  import util from "../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
  export default {
    name: "extrato-familia",
    mixins: [util],
    props: {//Propriedades que o objeto recebe como parametro
      model: Object, /*Solicitacao atual do Fornecedor*/
      dominio: Object,
      enums: Object
    },
    created() /*Metodo de start do componente*/{
    },
    computed: {//Campos computados
    },
    watch: { //Propriedades assistidas
      "enums.tipoUploadDeclaracao": {
        handler(newValue) { /*Se houver um novo valor*/
          // Só busca os formulários e declarações após o enums.tipoUploadDeclaracao
          // estiver carregado
          if (newValue != undefined) {
            this.retornaDocs();
          }
        },
      },
    },

    data() {//Declaracao de variaveis
      return {
        showBox: true,
        uploadDeclaracao: Object
      };
    },
    methods: {//Declaracao de todos os metodos
      retornaDocs(){
        //carrega os possiveis documentos de formularios e declaracoes
        let upload = {
          termoConcordanciaVeracidade: this.verificaDoc(this.model.uploadDeclaracao.find(
            x => x.tipDocumento === this.enums.tipoUploadDeclaracao.find(
              y => y.chave === 'TermoConcordanciaVeracidadeSaeb').valor)),
          comprovanteResidencia: this.verificaDoc(this.model.uploadDeclaracao.find(
            x => x.tipDocumento === this.enums.tipoUploadDeclaracao.find(
              y => y.chave === 'ComprovanteResidencia').valor)),
          procuracao: this.verificaDoc(this.model.uploadDeclaracao.find(
            x => x.tipDocumento === this.enums.tipoUploadDeclaracao.find(
              y => y.chave === 'Procuracao').valor)),
          declaracaoEmpregador: this.verificaDoc(this.model.uploadDeclaracao.find(
            x => x.tipDocumento === this.enums.tipoUploadDeclaracao.find(
              y => y.chave === 'DeclaracaoEmpregador').valor)),
          declaracaoSuperveniencia: this.verificaDoc(this.model.uploadDeclaracao.find(
            x => x.tipDocumento === this.enums.tipoUploadDeclaracao.find(
              y => y.chave === 'DeclaracaoSuperveniencia').valor)),
          declaracaoEnquadramento: this.verificaDoc(this.model.uploadDeclaracao.find(
            x => x.tipDocumento === this.enums.tipoUploadDeclaracao.find(
              y => y.chave === 'DeclaracaoEnquadramento').valor)),
        };
        this.uploadDeclaracao = upload;
      },
      openBox() {
        this.showBox = !this.showBox;
      },
      verificaDoc(obj) {
        var retorno = ""
        if (obj != null) {
          retorno = obj.arquivoUpload
        }
        return retorno;
      },
      baixarArquivo(arquivo) {
        //baixar o arquivo
        const numCgcFornecedor = this.$verificaPerfilCadastrador() ?
          this.model.numCgcFornecedor.replace(/[\W_]+/g, "") :
          null;
        fornecedorService.baixarArquivo(arquivo, numCgcFornecedor);
      }
    }
  };
</script>

<style scoped> /*CSS especifico do componente*/
  .infoDados .v-card {
    padding: 15px;
  }
  .infoDados .linhaInfo {
    display: block;
    padding: 5px 0;
  }
  .theme--light.v-table thead {
    background: none;
  }
</style>
